import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SERVICE_ICONS } from "@/lib/company";

export const ServiceGrid = ({ dark = true }) => {
  const [services, setServices] = useState(null);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => setServices([]));
  }, []);

  if (services === null) {
    return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px">{[0, 1, 2].map((i) => <div key={i} className="h-56 bg-white/5 animate-pulse" />)}</div>;
  }
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px ${dark ? "bg-white/10" : "bg-slate-200"} border ${dark ? "border-white/10" : "border-slate-200"}`} data-testid="services-grid">
      {services.map((s, i) => {
        const Icon = SERVICE_ICONS[s.icon] || SERVICE_ICONS.truck;
        return (
          <article key={s.id} className={`group relative p-8 lg:p-10 transition-colors duration-300 ${dark ? "bg-[#0B0C0E] hover:bg-[#14161A]" : "bg-white hover:bg-slate-50"}`} data-testid={`service-card-${i}`}>
            <span className="absolute top-6 right-8 font-mono text-xs text-slate-500">{String(i + 1).padStart(2, "0")}</span>
            <div className="h-12 w-12 flex items-center justify-center bg-[#E50914]/10 border border-[#E50914]/30 text-[#E50914] group-hover:bg-[#E50914] group-hover:text-white transition-colors duration-300">
              <Icon className="h-6 w-6" />
            </div>
            <h3 className={`mt-6 font-display text-2xl font-bold uppercase tracking-tight ${dark ? "text-white" : "text-slate-900"}`}>{s.title}</h3>
            <p className={`mt-3 text-sm leading-relaxed ${dark ? "text-slate-400" : "text-slate-600"}`}>{s.description}</p>
            <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[#E50914] group-hover:w-full transition-[width] duration-500" />
          </article>
        );
      })}
    </div>
  );
};
